import { useState } from "react";
import { ByWifiKeyDetails } from "./ByWifiKeyDetails";
import { useVillageWifiHttp } from "./hooks/useVillageWifiHttp";
import { ByWifiKeyDto } from "../../dtos/ByWifiKeyDto";
import { IconButton, InputAdornment, OutlinedInput, Stack } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { LoadingButton } from "@mui/lab";
import ClearIcon from '@mui/icons-material/Clear';


export const ByWifiKey : React.FC = ( ) => {
 
    const [ byWifiKeyDto, setByWifiKeyDto ] = useState< ByWifiKeyDto > ( );
    const [ isSearching, setIsSearching ] = useState<boolean>( false );
    const [ isSearchCompleted, setIsSearchCompleted ] = useState<boolean>( false );
    const [ wifiKey, setWifiKey ] = useState< string >( '' );

    
    const { getResidentByWifiKey } = useVillageWifiHttp( );


    const handleClearButtonClick = () => { 
        
        setIsSearchCompleted( false );
        setByWifiKeyDto( undefined );
        setWifiKey( '' );

    };


    const handleWifiKeyChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setWifiKey( event.target.value.trim( ) );


    const handleWifiKeySearchClick = ( ) => searchResidentByWifiKey( );


    const handleWifiKeyPress = ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( event.key !== 'Enter' ) {
            
            return;

        }

        searchResidentByWifiKey( );

    };


    const searchResidentByWifiKey = async( ) => {

        if( wifiKey.length === 0 ) {

            return;

        }

        setByWifiKeyDto( undefined );
        
        setIsSearching( true );

        const byWifiKeyDto = await getResidentByWifiKey( wifiKey );

        setIsSearching( false );
        setIsSearchCompleted( true );
                
        if( byWifiKeyDto ) {
        
            setByWifiKeyDto( byWifiKeyDto );

        }

    };    


    return(

        <Stack justifyContent="center" spacing={1} sx={{ alignItems :"center" }}>

            <Stack direction="row">

                <OutlinedInput
                    sx={{ 
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        height: '48px',
                        width: '360px' 
                    }}
                    onKeyPress={ handleWifiKeyPress }
                    value={ wifiKey }
                    onChange={ handleWifiKeyChange }
                    startAdornment = {
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    }
                    endAdornment = {
                        
                        wifiKey.length > 0
                            &&
                        <InputAdornment position="end">
                            <IconButton edge="end" onClick={ handleClearButtonClick } >

                                <ClearIcon sx={{ cursor: 'pointer'}} />
                            
                            </IconButton>
                        </InputAdornment>
                        
                    }
                    placeholder="Wi-Fi Key..."
                    disabled={ isSearching }
                />

                <LoadingButton
                    sx={{ 
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        boxShadow: 0, 
                        fontWeight: 'bold', 
                        textTransform: 'none', 
                    }}
                    loadingPosition="start"
                    startIcon={ <SearchIcon /> }
                    variant="contained"
                    disabled={ wifiKey.length === 0 }
                    onClick={ handleWifiKeySearchClick }
                    loading={ isSearching }
                >
                    Search
                </LoadingButton>

            </Stack>
            
            {

                ( isSearchCompleted && !isSearching )
                    &&
                (
                    byWifiKeyDto
                        ?
                    <ByWifiKeyDetails byWifiKeyDto={ byWifiKeyDto } wifiKey={ wifiKey } />
                        :
                    <div style={{color:'red'}}>*No results found for the search criteria</div>
                )

            }

        </Stack>

    );

};